var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _g, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIllustrationManual = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 95,
    viewBox: "0 0 119 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.0728 88.4446L62.2759 84.0123L13.9846 56.3595L6.88238 60.4918L55.0728 88.4446Z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 1.25445,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0728 94.1555L62.5945 89.8115V84.1006L55.0728 88.4446L6.8824 60.4918V66.2027L55.0728 94.1555Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.25445,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88235 66.2027L55.0728 94.1555V88.4446L6.88235 60.4918V66.2027Z",
    fill: "#F7F4FD",
    stroke: "#040222",
    strokeWidth: 1.25445,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.844 76.9455L80.0471 72.5133L31.7559 44.8604L24.6536 48.9927L72.844 76.9455Z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 1.25445,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.844 82.6564L80.3657 78.3124V72.6015L72.844 76.9455L24.6536 48.9927V54.7036L72.844 82.6564Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.25445,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6536 54.7036L72.844 82.6564V76.9455L24.6536 48.9927V54.7036Z",
    fill: "#F7F4FD",
    stroke: "#040222",
    strokeWidth: 1.25445,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6155 65.4464L97.8186 61.0142L49.5273 33.3613L42.4251 37.4936L90.6155 65.4464Z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 1.25445,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6155 71.1573L98.1372 66.8133V61.1024L90.6155 65.4464L42.4251 37.4936V43.2045L90.6155 71.1573Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.25445,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4251 43.2045L90.6155 71.1573V65.4464L42.4251 37.4936V43.2045Z",
    fill: "#F7F4FD",
    stroke: "#040222",
    strokeWidth: 1.25445,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M110.478 53.9473L117.681 49.515L69.3901 21.8622L62.2879 25.9944L110.478 53.9473Z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 1.25445,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M110.478 59.6581L118 55.3141V49.6032L110.478 53.9473L62.2879 25.9945V31.7053L110.478 59.6581Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.25445,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2879 31.7053L110.478 59.6581V53.9473L62.2879 25.9945V31.7053Z",
    fill: "#F7F4FD",
    stroke: "#040222",
    strokeWidth: 1.25445,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9182 8.07294L17.8612 2.86233L25.1176 2.60029L30.1746 7.8109L22.9182 8.07294Z",
    fill: "#F7F4FD",
    stroke: "#040222",
    strokeWidth: 0.913923,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5466 38.8566L5.48957 33.6459L12.746 33.3839L17.8031 38.5945L10.5466 38.8566Z",
    fill: "#F7F4FD",
    stroke: "#040222",
    strokeWidth: 0.0152321,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1003_2779",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 33,
    width: 13,
    height: 16
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71973 48.3792L5.48955 33.6462L12.746 33.3841L17.803 38.5948L6.71973 48.3792Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1003_2779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.71973 48.3792L5.48955 33.6462L12.746 33.3841L17.803 38.5948L6.71973 48.3792Z",
    fill: "#F7F4FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.03945 50.071L-1.41551 42.3897L9.28168 42.0034L16.7366 49.6847L6.03945 50.071Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 0.913923,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71973 48.3792L5.48955 33.6462L12.746 33.3841L17.803 38.5948L6.71973 48.3792Z",
    stroke: "#040222",
    strokeWidth: 0.913923,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1189 2.59971L12.7469 33.385L5.49048 33.647L17.8625 2.86175L25.1189 2.59971Z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 0.913923,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0633 2.43203L12.6912 33.2173L17.7483 38.4279L30.1203 7.64263L25.0633 2.43203Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 0.913923,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIllustrationManual);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/illustration-manual.9ead17fe0923638846384ec454fe9309.svg";